$(document).ready(function(){  
  $(".featured-collection__slider, #Highlights .slider").slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 4,
    dots: false,
    arrows: true,
    prevArrow: '<div class="arrow-left"><img src="//cdn.shopify.com/s/files/1/0113/6741/5872/t/19/assets/black-arrow-left.png?v=79504478389581545231634173325"></div>',
    nextArrow: '<div class="arrow-right"><img src="//cdn.shopify.com/s/files/1/0113/6741/5872/t/19/assets/black-arrow-right.png?v=13200163168748177421634173326"></div>',
    responsive: [
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }
    ]
  });

  setTimeout(function(){
  $(".product-recommendations__slider").slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 4,
    dots: false,
    arrows: true,
    prevArrow: '<div class="arrow-left"><img src="//cdn.shopify.com/s/files/1/0113/6741/5872/t/19/assets/black-arrow-left.png?v=79504478389581545231634173325"></div>',
    nextArrow: '<div class="arrow-right"><img src="//cdn.shopify.com/s/files/1/0113/6741/5872/t/19/assets/black-arrow-right.png?v=13200163168748177421634173326"></div>',
    responsive: [
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }
    ]
  });
  }, 2000);
});